import React, { useEffect, useCallback, useState} from 'react';
import {
    setMovingPadEdge
} from 'actions/index.js';
import {connect} from 'react-redux';

const START = 'START';
const END = 'END';

const EdgeHelper = ({
    pathPoints,
    setMovingPadEdge,
    edge
}) => { 
    let startNode = pathPoints.slice(0,2);
    startNode[1]+=10;
    let endNode = pathPoints.slice(pathPoints.length - 2, pathPoints.length );
    endNode[1]-=10;

    const startMoving = useCallback((e, mode) => {
        e.stopPropagation();
        let point = mode === START ? pathPoints.slice(pathPoints.length - 2) : pathPoints.slice(0, 2);
        let coords = {
            x1: point[0],
            y1: point[1],
            x2: e.clientX,
            y2: e.clientY
        };
        if (mode === START) {
            // we want to keep the dest but move the source
            console.log('set moving pad edge called 1');
            setMovingPadEdge({
                edge: edge,
                ... coords,
                destType: edge.destType,
                destId: edge.destId,
            });
        } else {
            console.log('set moving pad edge called 2');
            // we want to keep the source but move the dest
            setMovingPadEdge({
                edge: edge,
                ... coords,
                sourceType: edge.sourceType,
                sourceId: edge.sourceId,
            });
        }
    }, [edge]);
 
    return (
        <g>
          <circle
            onMouseDown={e => startMoving(e, START)}
            className="edge-helper" cx={startNode[0]} cy={startNode[1]} r={5} fill="white"/>
          <circle
            onMouseDown={e => startMoving(e, END)}
            className="edge-helper" cx={endNode[0]} cy={endNode[1]} r={5} fill="white"/>
        </g>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setMovingPadEdge: x => dispatch(setMovingPadEdge(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EdgeHelper);
